// @mui material components
import { Grid } from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDButton from "theme/components/MDButton";

import React from "react";
import { useNavigate } from "react-router-dom";

function P2PRequestHeader() {
  const navigate = useNavigate();
  return (
    <Grid item xs={12} md={12} lg={12}>
      <MDBox sx={{ marginBottom: "40px" }}>
        <MDBox display="flex" alignItems="center" justifyContent="flex-end">
          <MDBox>
            <MDButton
              variant="text"
              color="dark"
              onClick={() => {
                navigate("/p2p/ewallets");
              }}
            >
              MarketPlace
            </MDButton>
          </MDBox>
          <MDBox>
            <MDButton
              variant="text"
              color="dark"
              onClick={() => {
                navigate("/p2p/ewallets/my-requests");
              }}
            >
              My Requests
            </MDButton>
            <MDButton
              variant="link"
              color="dark"
              onClick={() => {
                navigate("/p2p/ewallets/history");
              }}
            >
              History
            </MDButton>
            <MDButton
              variant="link"
              color="dark"
              onClick={() => {
                navigate("/p2p/ewallets/transactions");
              }}
            >
              Transactions
            </MDButton>
          </MDBox>
        </MDBox>
      </MDBox>
    </Grid>
  );
}

export default P2PRequestHeader;
